import React, { useState } from 'react'
import dynamic from 'next/dynamic'
import { SearchProvider } from '@mc/algolia-search'
import { Dropdown, DropdownToggle } from '@mc/design-system'
import { useNav } from '../../navContext'
import { DropdownContentControlled } from '../DropdownContent'
import { SearchInput, blurSearchInput } from './SearchInput'

const SearchDropdown = dynamic(
  () =>
    import(
      /* webpackChunkName:'search-dropdown-subcategory-navigation' */
      './SearchDropdown'
    ).then((m) => m.SearchDropdown),
  { ssr: false },
)

export const Search = () => {
  const [show, setShowState] = useState(false)

  const { searchInputWidth } = useNav()

  const setShow = (newShow: boolean) => {
    setShowState(newShow)
    if (newShow === false) {
      blurSearchInput()
    }
  }

  return (
    <Dropdown placement='bottom-start' fixed ariaControls='ui-search-dropdown'>
      <SearchProvider showCategories={false} showArticles={false}>
        <DropdownToggle>
          <SearchInput setShow={setShow} />
        </DropdownToggle>

        <DropdownContentControlled
          show={show}
          setShow={setShow}
          style={{ width: searchInputWidth }}
        >
          <SearchDropdown />
        </DropdownContentControlled>
      </SearchProvider>
    </Dropdown>
  )
}
